import { Middleware } from 'redux';
import { promiseMatchOdds, promiseStatsTeamVersusRecent, promiseStatsTeamLastX, promiseStatsPlayerAggregate, promiseStatsRanking, promiseMatchDetailsExtended, promiseMatchEvents } from '../api/feedPromises';
import { IState } from '../store/state';
import { FETCH_MATCH_ODDS_SUCCEEDED, FETCH_MATCH_ODDS_FAILED, FETCH_MATCH_ODDS_REQUESTED, FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED, FETCH_STATS_TEAM_LAST_X_REQUESTED, FETCH_STATS_PLAYER_AGGREGATE_REQUESTED, FETCH_STATS_RANKING_REQUESTED, FETCH_STATS_TEAM_LAST_X_SUCCEEDED, FETCH_STATS_TEAM_LAST_X_FAILED, FETCH_STATS_TEAM_VERSUS_RECENT_FAILED, FETCH_STATS_TEAM_VERSUS_RECENT_SUCCEEDED, FETCH_STATS_PLAYER_AGGREGATE_SUCCEEDED, FETCH_STATS_PLAYER_AGGREGATE_FAILED, FETCH_STATS_RANKING_SUCCEEDED, FETCH_MATCH_DETAILS_EXTENDED_REQUESTED, FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED, FETCH_MATCH_DETAILS_EXTENDED_FAILED, FETCH_MATCH_EVENTS_SUCCEEDED, FETCH_MATCH_EVENTS_FAILED, FETCH_MATCH_EVENTS_REQUESTED, FETCH_MATCH_EVENTS_DELTA_SUCCEEDED, FETCH_MATCH_EVENTS_DELTA_FAILED, FETCH_MATCH_EVENTS_DELTA_REQUESTED } from '../actions/actionTypes';
import { promiseStatsPlayerAggregateCombinedValidated, promiseStatsTeamVersusRecentValidated, promiseStatsTeamLastXCombinedValidated, promiseMatchOddsValidated, promiseMatchEventsDeltaValidated } from '../api/validatedFeedPromises';

// TODO move odds call to matchFeedsMiddleware and remove this middleware from the store.

const pollerMiddleware: Middleware = store => next => action => {
    switch (action.type) {
        /*case FETCH_PLAYER_STATS_REQUESTED:
            promisePlayerStats(store.getState())
                .then(res => store.dispatch({ type: FETCH_PLAYER_STATS_SUCCEEDED, data: res.data }))
                .catch(error => store.dispatch({ type: FETCH_PLAYER_STATS_FAILED, error }));
            break;*/
        case FETCH_STATS_TEAM_VERSUS_RECENT_REQUESTED:
            requestStatsTeamVersusRecent(store,action);
            break;
        case FETCH_STATS_TEAM_LAST_X_REQUESTED:
            requestStatsTeamLastX(store,action);
            break;
        case FETCH_STATS_PLAYER_AGGREGATE_REQUESTED:
            fetchStatsPlayerAggregate(store,action);
            break;
        case FETCH_STATS_RANKING_REQUESTED:
            requestStatsRanking(store,action);
            break;
        case FETCH_MATCH_EVENTS_REQUESTED:
            fetchMatchEvents(store,action);
            break;
        case FETCH_MATCH_EVENTS_DELTA_REQUESTED:
            fetchMatchEventsDelta(store,action);
            break;
        /*case FETCH_MATCH_GET_REQUESTED:
            promiseMatchGet(store.getState(), action.matchId)
                .then(res => store.dispatch({ type: FETCH_MATCH_GET_SUCCEEDED, data: res.data }))
                .catch(error => store.dispatch({ type: FETCH_MATCH_GET_FAILED, error }));
            break;*/
        case FETCH_MATCH_ODDS_REQUESTED:
            fetchMatchOdds(store,action);
            break;
        case FETCH_MATCH_DETAILS_EXTENDED_REQUESTED:
            fetchMatchDetailsExtended(store,action);
            break;
    }
    return next(action);
}

function requestStatsTeamVersusRecent( store: any, action: any ) {
    promiseStatsTeamVersusRecentValidated(store.getState(), action.teamIdA, action.teamIdB, action.channelId)
        .then(res => store.dispatch({ type: FETCH_STATS_TEAM_VERSUS_RECENT_SUCCEEDED, data: res.data }))
        .catch(error => store.dispatch({ type: FETCH_STATS_TEAM_VERSUS_RECENT_FAILED, error }));
}

function requestStatsTeamLastX( store: any, action: any ) {
    promiseStatsTeamLastXCombinedValidated(store.getState(), action.teamIdA, action.teamIdB, action.channelId)
        .then(res => store.dispatch({ type: FETCH_STATS_TEAM_LAST_X_SUCCEEDED, data: res.data }))
        .catch(error => store.dispatch({ type: FETCH_STATS_TEAM_LAST_X_FAILED, error }));
}

function fetchStatsPlayerAggregate( store: any, action: any ) {
    promiseStatsPlayerAggregateCombinedValidated(store.getState(), action.tournamentId, action.teamIdA, action.teamIdB, action.matchId, action.channelId)
        .then(res => store.dispatch({ type: FETCH_STATS_PLAYER_AGGREGATE_SUCCEEDED, data: res.data }))
        .catch(error => store.dispatch({ type: FETCH_STATS_PLAYER_AGGREGATE_FAILED, error }));
}

function requestStatsRanking( store: any, action: any ) {
    promiseStatsRanking(store.getState(), action.tournamentId)
        .then(res => store.dispatch({ type: FETCH_STATS_RANKING_SUCCEEDED, data: res.data }))
        .catch(error => store.dispatch({ type: FETCH_STATS_RANKING_SUCCEEDED, error }));
}

function fetchMatchEvents( store: any, action: any ) {
    promiseMatchEvents(store.getState(),action.matchId)
        .then( response => store.dispatch({ type: FETCH_MATCH_EVENTS_SUCCEEDED, data: response.data, headers:response.headers }))
        .catch( error => store.dispatch({ type: FETCH_MATCH_EVENTS_FAILED, error }) );
}

function fetchMatchEventsDelta( store: any, action: any ) {
    promiseMatchEventsDeltaValidated(store.getState(),action.matchId)
        .then( response => store.dispatch({ type: FETCH_MATCH_EVENTS_DELTA_SUCCEEDED, data: response.data, headers:response.headers }) )
        .catch( error => store.dispatch({ type: FETCH_MATCH_EVENTS_DELTA_FAILED, error }) );
}

function fetchMatchOdds( store: any, action: any ) {
    promiseMatchOddsValidated(store.getState() as any as IState, action.matchId)
        .then(res => store.dispatch({ type: FETCH_MATCH_ODDS_SUCCEEDED, data: res.data, headers: res.headers }))
        .catch(error => store.dispatch({ type: FETCH_MATCH_ODDS_FAILED, error }));
}

function fetchMatchDetailsExtended( store: any, action: any ) {
    promiseMatchDetailsExtended(store.getState() as any as IState, action.matchId)
        .then(res => store.dispatch({ type: FETCH_MATCH_DETAILS_EXTENDED_SUCCEEDED, data: res.data, headers: res.headers }))
        .catch(error => store.dispatch({ type: FETCH_MATCH_DETAILS_EXTENDED_FAILED, error }));
}

export default pollerMiddleware;
